module.exports = __webpack_public_path__ + "static/media/Overall-Quality-of-Day-vs.-Social-Depth.4459a3c3.png";